import { Template } from '../../interfaces/Templates';

const formatDate = (date: Date): string =>
	(date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
	'/' +
	(date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) +
	'/' +
	date.getFullYear();

export const customTemplatesTableColumns = [
	{
		title: 'Template Name',
		id: 1,
		width: 150,
		component: ({ content }: { content: Template }) => content.name,
	},
	{
		title: 'Created',
		id: 2,
		component: ({ content }: { content: Template }) =>
			content.createdDate ? formatDate(new Date(content.createdDate)) : '',
		width: 70,
	},
	{
		title: 'Last Used',
		id: 3,
		component: ({ content }: { content: Template }) => (content.lastUsed ? formatDate(new Date(content.lastUsed)) : ''),
		width: 70,
	},
	{
		title: 'Last File Imported',
		id: 4,
		component: ({ content }: { content: Template }) => content.lastFileImported,
		width: 150,
	},
];

const mapColumnIdToName = ['name', 'createdDate', 'lastUsed', 'lastFileImported'];

export const getSortByColumnName = (columnId: number) => mapColumnIdToName[columnId - 1];
